import React from 'react';

interface NftColumnProps {
  className?: string;
  position: number;
  width: number;
}

export const NftColumn: React.FC<NftColumnProps> = ({
  className = '',
  children,
  position,
  width,
}) => {
  const isFirstElement = position === 0;
  const isOneColumnView = width === 1;
  let classNames: string = '';

  isFirstElement && isOneColumnView && (classNames = 'w-40');
  isFirstElement && !isOneColumnView && (classNames = 'w-60');

  !isFirstElement && isOneColumnView && (classNames = 'w-30');
  !isFirstElement && !isOneColumnView && (classNames = 'w-36');

  return (
    <div
      className={`
        select-none
        flex
        flex-1
        items-center
        border-b
        border-grey-10
        dark:border-grey-70
        h-10
        bg-white
        dark:bg-grey-90
        ${classNames}
        ${className}
      `}
    >
      {children}
    </div>
  );
};
